import React from 'react'
import { ReactComponent as ErrorImage } from 'App/assets/error-welbe.svg'
import { Container, Content } from './Expired.styles'

export const ExpiredInfo = () => {
	return (
		<Container>
			<Content>
				<h4>Encuesta NOM-035 finalizada</h4>
				<ErrorImage />
				<p>Lo sentimos, no estamos recibiendo más respuestas.</p>
			</Content>
		</Container>
	)
}
